/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export * from './pagination.component';
export * from './pagination.module';
export * from './pagination.types';
export * from './pagination-simple.component';
export * from './pagination-options.component';
export * from './pagination-item.component';
export * from './pagination-default.component';
